"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mockCertificateData = {
    certificate_preview_data: {
        email_or_name: 'User',
        course_display_name: 'Java',
        end_date: '29-SEP-2024',
        sha: '4d135b690a1a6a6b55b0ab0805e8b2f0201b082c',
        course_icon_url: 'https://picsum.photos/200?random=3',
        link: 'www.codebashing.com',
        completed_at: '29-SEP-2023',
    },
};
exports.default = mockCertificateData;
